import React from 'react';

import { TableName } from '@models/column';
import { Unset } from '@utils';

import { DraftEditorProps, TableColumnEditor } from '../field-widgets';
import { useFeatureDescriptorEditorContext } from '../../context';
import { AggregationDraft } from '../../models';

export const DistanceEditor = (props: DraftEditorProps<AggregationDraft>) => {
  const [state] = useFeatureDescriptorEditorContext();
  const latitutde1Table: TableName | Unset =
    state.aggregation['latitutde_1_column']?.table;
  const latitutde2Table: TableName | Unset =
    state.aggregation['latitutde_2_column']?.table;

  const allLatitudeAdt = props.tableColumns;
  const allLongitude = props.tableColumns;

  const longitude1 = latitutde1Table
    ? {
        [latitutde1Table]: allLongitude[latitutde1Table],
      }
    : {};
  const longitude2 = latitutde2Table
    ? {
        [latitutde2Table]: allLongitude[latitutde2Table],
      }
    : {};

  return [
    <TableColumnEditor
      {...props}
      label="latitutde_1_column"
      tableColumns={allLatitudeAdt}
    />,
    <TableColumnEditor
      {...props}
      label="longitude_1_column"
      tableColumns={longitude1}
    />,

    <TableColumnEditor
      {...props}
      label="latitutde_2_column"
      tableColumns={allLatitudeAdt}
    />,
    <TableColumnEditor
      {...props}
      label="longitude_2_column"
      tableColumns={longitude2}
    />,
  ];
};
